import React, { useEffect, useState, useMemo } from "react";
import { Dropdown } from "primereact/dropdown";
import { useAuth } from "../../AuthContext";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import { Tooltip } from "primereact/tooltip";
import {
  FaDatabase,
  FaCheckCircle,
  FaUser,
  FaUpload,
  FaFileExport,
  FaDownload,
} from "react-icons/fa";

import "primeicons/primeicons.css";

const Arquivo = () => {
  const { user } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [creatingBackup, setCreatingBackup] = useState(false);
  const [backups, setBackups] = useState([]);
  const [backupName, setBackupName] = useState("");
  const [visibleGerar, setVisibleGerar] = useState(false); //showDialog
  const [visibleRestaurar, setVisibleRestaurar] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [arquivoBackup, setArquivoBackup] = useState(null);
  const [importando, setImportando] = useState(false);
  const [progresso, setProgresso] = useState(0);
  const [mensagemImportacao, setMensagemImportacao] = useState("");

  // Carregar backups
  const carregarBackups = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/backups",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "include",
        },
      );

      const data = await response.json();

      console.log("Carregar Bkps = ", data.data);

      if (response.ok) {
        setBackups(data.data || []);
      } else {
        setError(data.message || "Erro ao carregar backups");
      }
    } catch (err) {
      setError("Erro de conexão com o servidor");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarBackups();
  }, []);

  // Criar backup
  const criarBackup = async () => {
    if (!backupName.trim()) {
      setError("Digite um nome para o backup");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/backup/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify({
            nome: backupName,
          }),
        },
      );

      // Tentar pegar a resposta mesmo se for erro
      let data;
      try {
        data = await response.json();
        console.log("Resposta do servidor:", data);
      } catch (jsonError) {
        console.error("Erro ao parsear JSON:", jsonError);
        const text = await response.text();
        console.log("Resposta em texto:", text);
        data = { message: "Resposta inválida do servidor" };
      }

      if (response.ok) {
        setSuccessMessage(`Backup "${backupName}" criado com sucesso!`);
        setBackupName("");
        setVisibleGerar(false);

        // Esperar um pouco antes de recarregar
        setTimeout(() => {
          carregarBackups();
        }, 1000);

        setTimeout(() => setSuccessMessage(""), 5000);
      } else {
        setError(data.message || `Erro ${response.status} ao criar backup`);
      }
    } catch (err) {
      console.error("Erro completo:", err);
      setError("Erro ao conectar com o servidor: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const downloadBackup = async (backupId, filename = "backup.sql") => {
    try {
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/backup/download/${backupId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Erro ao baixar backup");
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      setSuccessMessage("Download iniciado!");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (err) {
      console.error(err);
      setError("Erro ao baixar o backup");
      setTimeout(() => setError(null), 3000);
    }
  };

  // Excluir Backup
  const excluirBackup = async (backupId) => {
    if (
      !window.confirm(
        "Tem certeza que deseja excluir este backup? Esta ação não pode ser desfeita.",
      )
    ) {
      return;
    }

    try {
      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/backup/${backupId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erro ao excluir backup");
      }

      setSuccessMessage(data.message || "Backup excluído com sucesso!");

      // Recarregar lista
      setTimeout(() => {
        carregarBackups();
        setSuccessMessage("");
      }, 2000);
    } catch (err) {
      console.error("Erro na exclusão:", err);
      setError(err.message || "Erro ao excluir backup");
      setTimeout(() => setError(null), 3000);
    }
  };

  // Formatar data
  const formatarData = (dataString) => {
    try {
      const data = new Date(dataString);
      return data.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return dataString;
    }
  };

  // Função para lidar com seleção de arquivo
  const handleSelecionarArquivo = (event) => {
    const file = event.target.files[0];
    if (file) {
      setArquivoBackup(file);
    }
  };

  // Função para importar backup
  const handleImportarBackup = async () => {
    if (!arquivoBackup) {
      setMensagemImportacao(
        "❌ Por favor, selecione um arquivo .sql para importar",
      );
      return;
    }

    if (!arquivoBackup.name.endsWith(".sql")) {
      setMensagemImportacao("❌ Apenas arquivos .sql são permitidos");
      return;
    }

    if (
      !window.confirm(
        "⚠️ ATENÇÃO CRÍTICA!\n\nIsso vai SOBRESCREVER todos os dados atuais do sistema.\n\n• Todos os agendamentos serão substituídos\n• Todos os pacientes serão substituídos\n• Todos os caixas serão substituídos\n\nTem ABSOLUTA certeza que deseja continuar?",
      )
    ) {
      return;
    }

    setImportando(true);
    setProgresso(0);
    setMensagemImportacao("🔄 Preparando importação...");

    const formData = new FormData();
    formData.append("backup_file", arquivoBackup);

    console.log("🔍 DEBUG - Arquivo selecionado:", {
      name: arquivoBackup.name,
      size: arquivoBackup.size,
      type: arquivoBackup.type,
      lastModified: arquivoBackup.lastModified,
    });

    try {
      // Simular progresso
      const progressInterval = setInterval(() => {
        setProgresso((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 500);

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/backup/import",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token}`,
            // Não usar Content-Type para FormData - o browser define automaticamente
          },
          body: formData,
        },
      );

      clearInterval(progressInterval);
      setProgresso(100);

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || `Erro ${response.status} na importação`,
        );
      }

      if (data.success) {
        setMensagemImportacao(`
                    ✅ BACKUP IMPORTADO COM SUCESSO!

                    • Queries executadas: ${data.data?.queries_executadas || "N/A"}
                    • Erros encontrados: ${data.data?.erros || 0}

                    O sistema será recarregado em 5 segundos...
            `);

        // Recarregar a página após 5 segundos
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      } else {
        setMensagemImportacao(`❌ Falha na importação: ${data.message}`);
      }
    } catch (err) {
      console.error("Erro completo na importação:", err);
      setMensagemImportacao(
        `❌ ERRO CRÍTICO: ${err.message || "Erro desconhecido"}`,
      );
    } finally {
      setImportando(false);
      setTimeout(() => setProgresso(0), 2000);
    }
  };

  // Função auxiliar para formatar tamanho
  const formatarTamanho = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  {
    /* Return Principal */
  }
  return (
    <div
      style={{
        fontFamily: "'Rajdhani', sans-serif",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Modal para criar backup */}
      <Dialog
        visible={visibleGerar}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            setBackupName("");
            setVisibleGerar(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaDatabase style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  CRIAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  BACKUP
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "10px 0" }}>
            {/* 1ª Linha - Nome e CNPJ */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Nome */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaDatabase
                      style={{ color: "#3498DB", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Nome do Backup *
                    </span>
                  </div>
                  <InputText
                    placeholder="Backup Completo Janeiro 2024"
                    id="backupName"
                    value={backupName}
                    onChange={(e) => setBackupName(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                setBackupName("");
                setVisibleGerar(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "CRIANDO..." : "CRIAR BACKUP"}
              icon="pi pi-database"
              onClick={criarBackup}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading || !backupName.trim()}
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Modal para restaurar backup */}
      <Dialog
        visible={visibleRestaurar}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            setBackupName("");
            setVisibleRestaurar(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaDatabase style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  RESTAURAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  BACKUP
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "10px 0" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Nome */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaDatabase
                      style={{ color: "#3498DB", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Selecionar Arquivo de Backup *
                    </span>
                  </div>

                  {/* Botão Adicionar */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      padding: "10px",
                      backgroundColor: "#fff",
                      border: "1px solid #e8e8e8",
                      borderRadius: "6px",
                    }}
                  >
                    {/* Botão Adicionar */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                    >
                      <Button
                        label="SELECIONAR ARQUIVO"
                        icon="pi pi-folder-open"
                        onClick={() =>
                          document.getElementById("backup-file-input").click()
                        }
                        className="p-button-success p-button-sm"
                        style={{
                          outline: "none",
                          boxShadow: "0 2px 4px rgba(40, 167, 69, 0.2)",
                          padding: "6px 20px",
                          minWidth: "100px",
                          borderColor: "#28a745",
                          backgroundColor: "#28a745",
                          color: "white",
                          fontWeight: "600",
                          fontSize: "0.9rem",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                        disabled={importando}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      border: arquivoBackup
                        ? "2px dashed #27ae60"
                        : "2px dashed #ddd",
                      borderRadius: "6px",
                      padding: "20px",
                      textAlign: "center",
                      backgroundColor: arquivoBackup ? "#f0fff0" : "#f9f9f9",
                      transition: "all 0.3s",
                    }}
                  >
                    {arquivoBackup ? (
                      <div>
                        <div style={{ color: "#27ae60", marginBottom: "10px" }}>
                          <FaCheckCircle size={24} />
                        </div>
                        <div style={{ fontWeight: "500", marginBottom: "5px" }}>
                          {arquivoBackup.name}
                        </div>
                        <div style={{ color: "#666", fontSize: "0.9rem" }}>
                          {formatarTamanho(arquivoBackup.size)}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div style={{ color: "#3498db", marginBottom: "10px" }}>
                          <FaUpload size={24} />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                          Clique para selecionar ou arraste um arquivo .sql
                        </div>
                        <input
                          type="file"
                          id="backup-file-input"
                          accept=".sql"
                          onChange={handleSelecionarArquivo}
                          style={{ display: "none" }}
                          disabled={importando}
                        />
                      </div>
                    )}
                  </div>

                  {/* Progresso e Mensagens */}
                  {importando && (
                    <div
                      style={{
                        marginTop: "15px",
                        padding: "10px",
                        backgroundColor: "#e8f4fd",
                        borderRadius: "6px",
                        borderLeft: "4px solid #3498db",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "5px",
                        }}
                      >
                        <span style={{ fontWeight: "500", color: "#2c3e50" }}>
                          Importando backup...
                        </span>
                        <span style={{ fontWeight: "600", color: "#3498db" }}>
                          {progresso}%
                        </span>
                      </div>
                      <div
                        style={{
                          height: "6px",
                          backgroundColor: "#ddd",
                          borderRadius: "3px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${progresso}%`,
                            backgroundColor: "#3498db",
                            transition: "width 0.3s",
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {mensagemImportacao && (
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: mensagemImportacao.includes("❌")
                          ? "#fde8e8"
                          : mensagemImportacao.includes("✅")
                            ? "#f0fff0"
                            : "#fff8e1",
                        borderRadius: "6px",
                        borderLeft: "4px solid",
                        borderLeftColor: mensagemImportacao.includes("❌")
                          ? "#e74c3c"
                          : mensagemImportacao.includes("✅")
                            ? "#27ae60"
                            : "#f39c12",
                        whiteSpace: "pre-line",
                        fontSize: "0.9rem",
                        lineHeight: "1.5",
                      }}
                    >
                      {mensagemImportacao}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                setArquivoBackup(null);
                setMensagemImportacao("");
                setVisibleRestaurar(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={importando}
            />
            <Button
              label={importando ? "IMPORTANDO..." : "IMPORTAR BACKUP"}
              icon={importando ? "pi pi-spinner pi-spin" : "pi pi-database"}
              onClick={handleImportarBackup}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
                backgroundColor: importando ? "#95a5a6" : "#27ae60",
                borderColor: importando ? "#95a5a6" : "#27ae60",
              }}
              disabled={importando || !arquivoBackup}
            />
          </div>
        </>
      </Dialog>

      {/* Barra superior vermelha */}
      <div
        style={{
          backgroundColor: "#B83732",
          height: "40px",
          minHeight: "40px",
          width: "100%",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          fontWeight: "bold",
          position: "relative",
          zIndex: 10,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* lado esquerdo */}
        <div></div>

        {/* Centro */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            icon="pi pi-refresh"
            className="icon-button-titulo"
            onClick={() => carregarBackups()}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon="pi pi-file-import"
            className="icon-button-titulo"
            onClick={() => setVisibleRestaurar(true)}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon="pi pi-plus"
            className="icon-button-titulo"
            onClick={() => setVisibleGerar(true)}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
        </div>

        {/* lado direito */}
        <div></div>
      </div>

      {/* Conteúdo abaixo da barra */}
      <div style={{ flex: 1, padding: "10px" }}>
        {/* MOSTRAR RESERVAS DO DIA SELECIONADO - SEMPRE VISÍVEL */}
        <div style={{ borderRadius: "8px", padding: "0 15px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #E2E8F0",
            }}
          >
            <div style={{ marginTop: "7px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  gap: "5px",
                }}
              >
                <FaDownload style={{ color: "#B83732", fontSize: "1.2rem" }} />
                <h3 style={{ margin: 0, color: "#424242" }}>BACKUP</h3>
              </div>
            </div>
          </div>

          {/* InputSwitch */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              marginBottom: "30px",
            }}
          ></div>

          {/* Grids */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 8px",
            }}
          >
            {backups.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  border: "2px dashed #e8e8e8",
                }}
              >
                <FaDownload
                  style={{
                    fontSize: "3rem",
                    color: "#B83732",
                    marginBottom: "15px",
                    opacity: 0.5,
                  }}
                />
                <h3
                  style={{
                    color: "#2c3e50",
                    margin: "0 0 10px 0",
                    fontSize: "1.2rem",
                    fontWeight: "600",
                  }}
                >
                  Nenhum backup encontrado
                </h3>
              </div>
            ) : (
              <div
                className="grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", // Alterado para 280px
                  gap: "15px",
                  alignItems: "stretch",
                }}
              >
                {backups.map((backup) => (
                  <div key={backup.id}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      {/* Informações */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          marginBottom: "5px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #e8e8e8",
                        }}
                      >
                        <FaDatabase
                          style={{
                            fontSize: "2.2rem",
                            color: "#D65A55",
                            flexShrink: 0,
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: "0",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {backup.nome}
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px", // Reduzido
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.8rem", // Reduzido
                                color: "#7f8c8d",
                              }}
                            >
                              {backup.data_formatada ||
                                formatarData(backup.data_criacao)}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Detalhes do Agendamento */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "6px",
                          marginBottom: "5px",
                        }}
                      >
                        {/* Coluna 1 */}
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e8e8e8",
                            padding: "6px",
                            borderRadius: "6px",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaUser
                              style={{ color: "#2980b9", fontSize: "0.75rem" }}
                            />{" "}
                            {/* Reduzido */}
                            <span
                              style={{
                                fontSize: "0.8rem", // Reduzido
                                color: "#2c3e50",
                                fontWeight: "500",
                              }}
                            >
                              {backup.usuario_nome || "Sistema"}
                            </span>
                          </div>
                        </div>

                        {/* Coluna 2 */}
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e8e8e8",
                            padding: "6px",
                            borderRadius: "6px",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaDatabase
                              style={{ color: "#d35400", fontSize: "0.75rem" }}
                            />{" "}
                            {/* Reduzido */}
                            <span
                              style={{
                                fontSize: "0.8rem", // Reduzido
                                color: "#2c3e50",
                                fontWeight: "500",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {backup.tamanho_formatado ||
                                (backup.tamanho
                                  ? Math.round(backup.tamanho / 1024) + " KB"
                                  : "N/A")}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Cidade */}
                      <div
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e8e8e8",
                          padding: "6px",
                          borderRadius: "6px",
                          marginBottom: "6px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FaDatabase
                            style={{ color: "#e74c3c", fontSize: "0.75rem" }}
                          />{" "}
                          {/* Reduzido */}
                          <span
                            style={{
                              fontSize: "0.8rem", // Reduzido
                              color: "#7f8c8d",
                              fontWeight: "600",
                            }}
                          >
                            {backup.tabelas || "N/A"} Tabelas
                          </span>
                        </div>
                      </div>

                      {/* Ações Secundárias */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          paddingTop: "5px",
                          gap: "5px",
                          marginTop: "auto",
                          borderTop: "1px solid #e8e8e8",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <Button
                            icon="pi pi-download"
                            onClick={() =>
                              downloadBackup(backup.id, backup.nome_arquivo)
                            }
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                            }}
                            tooltip="Download"
                            tooltipOptions={{ position: "top" }}
                          />
                          <Button
                            icon="pi pi-trash"
                            onClick={() => excluirBackup(backup.id)}
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                            }}
                            tooltip="Excluir"
                            tooltipOptions={{ position: "top" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Loading Spinner */}
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="8"
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default Arquivo;
